import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { GkComponentsModule, GkMapModule } from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { createTranslateLoader } from '../address-number-request-portal/address-number-request-portal.module';
import { BuildingOrPartUseChangeRoutingModule } from './building-or-part-use-change-routing.module';
import { BOPUCNewRequestComponent } from './new-request/new-request.component';
import { BOPUCNewRequestFormService } from './services/new-request-form/new-request-form.service';

@NgModule({
  declarations: [BOPUCNewRequestComponent],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    BuildingOrPartUseChangeRoutingModule,
  ],
  providers: [BOPUCNewRequestFormService],
})
export class BuildingOrPartUseChangeModule {}
